<script lang="ts">

    import type UpsellingAlternative from '../api/UpsellingAlternative';
    import { getAlternative } from '../api/getAlternative';
    import OnexC from './OnexC.svelte';
    import tracker from '../tracking/Tracker';
    import type UpsellingComponentProps from './UpsellingComponentProps';

    const PDP_UPSELLING_SLOT_ID = 'pdp_upselling__slot';

    let { variationId }: UpsellingComponentProps = $props();
    let data = $state<UpsellingAlternative | undefined>();

    $effect(() => {
      if (!variationId) {
        return;
      }
      getAlternative(variationId).then((upsellingAlternative) => {
        data = upsellingAlternative;
        if (data) {
          const pdpUpsellingSlot = document.getElementById(PDP_UPSELLING_SLOT_ID);
          pdpUpsellingSlot?.classList.remove('pl_hidden');
          tracker.addToPageImpression({ product_Upselling: 'available' });
        }
      });
    });

</script>

{#if variationId && data}
    <div class='ft5_upselling-service--survey' style="display: none"></div>
    <OnexC
        variationId={variationId}
        animated={false}
        brandName={data.brandName}
        name={data.name}
        imageAltText={data.imageAltText}
        imageUrl={data.imageUrl}
        variationsComparisonHeading={data.variationsComparisonHeading}
        variationsComparisonCaption={data.variationsComparisonCaption}
        retailPrice={data.retailPrice}
        suggestedRetailPrice={data.suggestedRetailPrice}
        normPrice={data.normPrice}
        normUnit={data.normUnit}
        variationUrl={data.variationUrl}
        averageRatingRounded={data.averageRatingRounded}
        numberOfReviews={data.numberOfReviews}
        energyEfficiencyClass={data.energyEfficiencyClass}
        energyEfficiencyColor={data.energyEfficiencyColor}
        energyEfficiencyLabelVersion={data.energyEfficiencyUniform ? 'uniform' : 'default'}
    />
{/if}
